import React from 'react';
import { BENZINGA_LOGO_URL, JsonLd } from '@benzinga/seo';

const logoPNG = 'https://www.benzinga.com/next-assets/images/schema-publisher-logo-benzinga.png';

// TODO: Temporary copies of the global schemas still defined in `@benzinga/seo/Meta`.
// Remove these once the remaining apps finish the App Router migration.
const structuredDataCompany = {
  '@context': 'https://schema.org',
  '@type': 'NewsMediaOrganization',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'US',
    addressLocality: 'Detroit',
    addressRegion: 'MI',
    postalCode: '48226',
    streetAddress: '1 Campus Martius Suite 200',
  },
  brand: [
    {
      '@type': 'Brand',
      name: 'PreMarket Playbook',
      url: 'https://www.benzinga.com/premarket',
    },
    {
      '@type': 'Brand',
      name: 'Benzinga Markets',
      url: 'https://www.benzinga.com/markets/',
    },
    {
      '@type': 'Brand',
      name: 'Benzinga Pro',
      url: 'https://pro.benzinga.com/',
    },
    {
      '@type': 'Brand',
      name: 'Benzinga Cloud: Data & APIs',
      url: 'https://www.benzinga.com/apis',
    },
    {
      '@type': 'Brand',
      name: 'Benzinga Events',
      url: 'https://www.benzinga.com/events',
    },
    {
      '@type': 'Brand',
      name: 'Benzinga Money',
      url: 'https://www.benzinga.com/money/',
    },
  ],
  email: 'info@benzinga.com',
  image: BENZINGA_LOGO_URL,
  legalName: 'Benzinga',
  logo: logoPNG,
  name: 'Benzinga',
  sameAs: [
    'https://www.facebook.com/pages/Benzingacom/159483118580?v=app_7146470109',
    'https://twitter.com/benzinga',
    'https://www.linkedin.com/company/benzinga',
    'https://plus.google.com/108838891574408087738/posts',
    'https://www.youtube.com/user/BenzingaTV',
  ],
  telephone: '877-440-9464',
  url: 'https://www.benzinga.com/',
};

const sitelinkSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Benzinga',
  potentialAction: {
    '@type': 'SearchAction',
    'query-input': 'required name=search_term_string',
    target: 'https://www.benzinga.com/search/fast?cx={search_term_string}',
  },
  url: 'https://www.benzinga.com/',
};

const voiceSearchSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Benzinga',
  speakable: {
    '@type': 'SpeakableSpecification',
    // Only reference elements guaranteed to exist on every page. The
    // `<meta name="description">` tag is omitted on pages without a teaser/description,
    // which caused Google's Rich Results validator to flag a "No matches found" error.
    xpath: ['/html/head/title'],
  },
  url: 'https://www.benzinga.com/',
};

export const RootSchema = () => {
  return (
    <>
      <JsonLd data={structuredDataCompany} id="structuredDataCompany-schema" />
      <JsonLd data={voiceSearchSchema} id="voice-search-schema" />
      <JsonLd data={sitelinkSchema} id="sitelink-search-schema" />
    </>
  );
};
